export enum CaseActivity {
  Opened = 0,
  Closed = 1,
}
